import Vue from "vue";
const vm = new Vue();

export const getReceiptCodPop = (transactionId) => {
    return new Promise((resolve, reject) => {
        vm.$http
        .get(vm.$API_URL + `/shop/order/cod/${transactionId}`, {
            headers: {
                Token: localStorage.getItem("access_token"),
            }
        })
        .then((res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }else{
                resolve(res.data.data);
            }
        });
    });
};